/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Site_NameInputs */

const en_site_name = /** @type {(inputs: Site_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seek AI`)
};

const zh_site_name = /** @type {(inputs: Site_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seek AI`)
};

/**
* | output |
* | --- |
* | "Seek AI" |
*
* @param {Site_NameInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const site_name = /** @type {((inputs?: Site_NameInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Site_NameInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_site_name(inputs)
	return zh_site_name(inputs)
});
export { site_name as "site.name" }